import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  constructor(private translate: TranslateService) { }

  public handleError(error: HttpErrorResponse): string { 
    let errorMessage;

    if (error.status == 0) {
      errorMessage = this.translate.instant('ERROR.GENERAL.HTTP_NO_RESPONSE');
    } else if (error.status == 500) {
      errorMessage = this.translate.instant('ERROR.GENERAL.HTTP_GENERAL_ERROR');
    } else if (error.status == 588) {
      errorMessage = this.translate.instant('ERROR.GENERAL.HTTP_TIMEOUT_ERROR');
    } else if (error.status == 401){
      errorMessage = this.translate.instant('ERROR.LOGIN.FAILED_LOGIN');
    } else if (error.error instanceof ErrorEvent) { 
      errorMessage = this.translate.instant('ERROR.GENERAL.CLIENT_ERROR') + ": " + error.message;
    } else { 
      errorMessage = this.translate.instant('ERROR.GENERAL.UNKNOWN_ERROR') + ",  " + error.status + ":" + error.error;
    };

    return errorMessage;
  }
}
